import React from "react"

import TopicCard from "./topiccard"

/** First N cards get fetchPriority high (no lazy); rest lazy-load to avoid starving LCP. */
const FETCH_PRIORITY_TOPIC_CARD_COUNT = 6

// lists a bunch of topics
const TopicList = ({topics, mini, cols, hideImage, gridClass, topicRanksBySlug}) => {

  const columns = cols || 4;
    
  return (
    <ul className={`mt-2 grid overflow-visible ${gridClass || `grid-cols-1 sm:grid-cols-2 lg:grid-cols-${columns}`} gap-x-4 ${mini ? 'gap-y-6' : 'gap-y-8'} sm:gap-x-6 xl:gap-x-8`}>
      {topics.map((t, index) => (
        <TopicCard
          key={t.slug}
          topic={t}
          mini={mini}
          hideImage={hideImage}
          topicRank={topicRanksBySlug ? topicRanksBySlug[t.slug] : undefined}
          fetchPriorityHigh={index < FETCH_PRIORITY_TOPIC_CARD_COUNT}
        />
      ))}
    </ul>
  )
}

export default TopicList;

